import React from "react";
import Navbar from "./Header/Navbar.js";
import { Outlet } from "react-router-dom";
import Footer from "./Footer/footer.js";

function MainPage() {
  return (
    <>
      <Navbar />
      <div>
        <Outlet />
      </div>
      <Footer />
    </>
  );
}

export default MainPage;
